import React from "react";
import { BrandLogo } from "@/components/BrandLogo";

const WORD = { sm: "text-base", md: "text-lg", lg: "text-2xl" };
const BADGE = { sm: "w-8 h-8", md: "w-9 h-9", lg: "w-11 h-11" };
const IC = { sm: "w-5 h-5", md: "w-6 h-6", lg: "w-7 h-7" };

export const BrandMark = ({ size = "md", subtitle = "Automotive Files", showSub = true }) => (
  <div className="flex items-center gap-3" data-testid="brandmark">
    <div className={`${BADGE[size] || BADGE.md} grid place-items-center rounded-sm brand-badge`}>
      <BrandLogo className={IC[size] || IC.md} />
    </div>
    <div className="leading-tight">
      <div className={`brand-word font-display font-bold tracking-widest ${WORD[size] || WORD.md}`}>IMPERIUM</div>
      {showSub && <div className="font-mono text-[8px] tracking-[0.34em] uppercase brand-sub mt-0.5">{subtitle}</div>}
    </div>
  </div>
);
